export const savingData = {
  namespaced: true,

  state: () => ({
    pagesData: {}, // { [pageKey]: { scrollPositions: number, ...otherData } }
    // Session overrides after toggle — landings often get stale/missing is_favorite from fetchOne
    courseFavorites: {}, // { [courseId]: boolean }
  }),

  getters: {
    getPageData: (state) => (pageKey) => {
      return state.pagesData[pageKey] || null
    },
    getScrollPosition: (state) => (pageKey) => {
      return state.pagesData[pageKey]?.scrollPosition || 0
    },
    getCourseFavorite: (state) => (courseId) => {
      if (courseId == null) {
        return undefined
      }
      const id = String(courseId)
      if (Object.prototype.hasOwnProperty.call(state.courseFavorites, id)) {
        return state.courseFavorites[id]
      }

      const pageKeys = [
        'MarketplaceBroadcasts',
        'MarketplaceMasterClasses',
        'MarketplaceCourses',
        'DesktopBroadcasts',
        'DesktopMasterClasses',
        'DesktopCourses',
      ]
      const listKeys = ['courses', 'searchCourses']

      for (const pageKey of pageKeys) {
        const saveState = state.pagesData[pageKey]?.saveState
        if (!saveState) {
          continue
        }
        for (const listKey of listKeys) {
          const list = saveState[listKey]
          if (!Array.isArray(list)) {
            continue
          }
          for (const item of list) {
            if (item == null) {
              continue
            }
            if (String(item.id) === id || String(item.course?.id) === id) {
              if (item.is_favorite !== undefined) {
                return !!item.is_favorite
              }
              if (item.course?.is_favorite !== undefined) {
                return !!item.course.is_favorite
              }
            }
          }
        }
      }

      return undefined
    },
  },

  actions: {
    savePageData({ state, commit }, { pageKey, data }) {
      commit('SET_PAGE_DATA', { pageKey, data })
    },

    saveScrollPosition({ commit }, { pageKey, position }) {
      commit('SET_SCROLL_POSITION', { pageKey, position })
    },

    clearPageData({ commit }, pageKey) {
      commit('CLEAR_PAGE_DATA', pageKey)
    },

    clearAllPageData({ commit }, { exclude, including } = {}) {
      commit('CLEAR_ALL_PAGE_DATA', { exclude, including })
    },

    syncCourseFavorite({ commit }, { courseId, isFavorite }) {
      commit('SYNC_COURSE_FAVORITE', { courseId, isFavorite })
    },
  },

  mutations: {
    SET_PAGE_DATA(state, { pageKey, data }) {
      state.pagesData[pageKey] = {
        ...(state.pagesData[pageKey] || {}),
        ...data,
      }
    },

    SET_SCROLL_POSITION(state, { pageKey, position }) {
      if (!state.pagesData[pageKey]) {
        state.pagesData[pageKey] = {}
      }
      state.pagesData[pageKey].scrollPosition = position
    },

    CLEAR_PAGE_DATA(state, pageKey) {
      if (state.pagesData[pageKey]) {
        const newData = { ...state.pagesData }
        delete newData[pageKey]
        state.pagesData = newData
      }
    },

    CLEAR_ALL_PAGE_DATA(state, params = {}) {
      // todo: exclude, including
      const {exclude, including} = params

      const excludeData = {}

      if(exclude && exclude.length) {
        exclude.forEach(key => excludeData[key] = state.pagesData[key])
      }

      state.pagesData = {
        ...excludeData,
        // Home: state.pagesData.Home
      }
    },

    SYNC_COURSE_FAVORITE(state, { courseId, isFavorite }) {
      if (courseId == null) {
        return
      }

      const id = String(courseId)
      const value = !!isFavorite
      state.courseFavorites = {
        ...state.courseFavorites,
        [id]: value,
      }

      const pageKeys = [
        'MarketplaceBroadcasts',
        'MarketplaceMasterClasses',
        'MarketplaceCourses',
        'DesktopBroadcasts',
        'DesktopMasterClasses',
        'DesktopCourses',
      ]
      const listKeys = ['courses', 'searchCourses']

      for (const pageKey of pageKeys) {
        const saveState = state.pagesData[pageKey]?.saveState
        if (!saveState) {
          continue
        }

        for (const listKey of listKeys) {
          const list = saveState[listKey]
          if (!Array.isArray(list)) {
            continue
          }

          for (const item of list) {
            if (item == null) {
              continue
            }
            const matches = String(item.id) === id || String(item.course?.id) === id
            if (!matches) {
              continue
            }
            item.is_favorite = value
            if (item.course) {
              item.course.is_favorite = value
            }
          }
        }
      }
    },
  }
}
